import { ReportStatusResult, ReportStatusParams } from 'app/dataTypes/reports/status'

import type { Request } from '../../index'


type ApiParams = {
  report_id: number,
}

export const convertParams = (params: ReportStatusParams): [ApiParams, null] => {
  const { reportID } = params
  return [{ report_id: parseInt(reportID, 10) }, null]
}

export const convertResult = (res: number): ReportStatusResult => {
  return res
}

export const GET_REPORTS_STATUS: Request<
  ReportStatusParams,
  ReportStatusResult,
  void
> = ['reports/status', 'get', ['data', 'status_in_percents']]
